import {
  SET_SERVICIOS_IDA,
  SET_SERVICIOS_VUELTA,
  FILTRAR_SERVICIOS,
  SET_BUSQUEDA,
  RESET_BUSQUEDA,
  SET_SERVICIO_IDA_SELECTED,
  SET_SERVICIO_VUELTA_SELECTED,
  SET_HORA_HAPROX_VUELTA,
  SET_VIAJE_VUELTA_ACTIVO,
  ERROR_BUSQUEDA_SERVICIOS,
  SET_MENSAJE_RANGO,
} from '../types';

import moment from 'moment';

// function setFecha() {
//   const fechaCurrent = moment().toDate();

//   var endTime = moment(fechaCurrent).format('YYYY-MM-DD 20:00');

//   if (moment(fechaCurrent).isAfter(endTime)) {
//     return {
//       fecha: moment(fechaCurrent).add(1, 'days'),
//       hora: moment(fechaCurrent).add(1, 'days').format('YYYY-MM-DD 11:00'),
//     };
//   } else {
//     return { fecha: fechaCurrent, hora: fechaCurrent };
//   }
// }

const ex = { fecha: moment().toDate(), hora: moment().toDate() }; //setFecha();

const initialState = {
  busqueda: {
    linea: 0,
    estacionOrigen: 0,
    estacionDestino: 0,
    horarioAprox: 'salida',
    hora: ex.hora,
    fecha: ex.fecha,
  },
  serviciosSeleccionados: { ida: null, vuelta: null },
  serviciosRow: { ida: null, vuelta: null },
  servicios: { ida: null, vuelta: null },
  cantidad: 1,
  vueltaActiva: false,
  mensajeRango: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BUSQUEDA: {
      return {
        ...state,
        busqueda: action.payload,
      };
    }
    case RESET_BUSQUEDA: {
      return initialState;
    }
    case SET_SERVICIOS_IDA: {
      return {
        ...state,
        serviciosRow: { ...state.serviciosRow, ida: action.payload },
      };
    }
    case SET_SERVICIOS_VUELTA: {
      return {
        ...state,
        serviciosRow: { ...state.serviciosRow, vuelta: action.payload },
      };
    }
    case FILTRAR_SERVICIOS: {
      var cantidad = 1 + action.payload.cantidad;
      var servic = null;

      //TODO :

      if (!state.vueltaActiva) {
        servic = {
          ...state.servicios,
          ida: state.serviciosRow.ida.slice(0, 3),
        };

        if (typeof action.payload.numeroTrenFiltro !== 'undefined') {
          servic = {
            ...state.servicios,
            ida: servic.ida.filter(
              (s) => s.servicio.numero !== action.payload.numeroTrenFiltro
            ),
          };
        }
      } else {
        servic = {
          ...state.servicios,
          vuelta: state.serviciosRow.vuelta.slice(0, 3),
        };
      }

      return {
        ...state,
        servicios: servic,
        cantidad,
      };
    }
    case SET_SERVICIO_IDA_SELECTED: {
      return {
        ...state,
        serviciosSeleccionados: {
          ...state.serviciosSeleccionados,
          ida: {
            servicio: {
              servicioId: action.payload.servicio.id,
              desdeId: state.busqueda.estacionOrigen,
              hastaId: state.busqueda.estacionDestino,
              cantidad: state.cantidad,
            },
          },
        },
      };
    }
    case SET_SERVICIO_VUELTA_SELECTED: {
      return {
        ...state,
        serviciosSeleccionados: {
          ...state.serviciosSeleccionados,
          vuelta: {
            servicio: {
              servicioId: action.payload.servicio.id,
              desdeId: state.busqueda.estacionDestino,
              hastaId: state.busqueda.estacionOrigen,
              cantidad: state.cantidad,
            },
          },
        },
      };
    }
    case SET_HORA_HAPROX_VUELTA: {
      return {
        ...state,
        busqueda: {
          ...state.busqueda,
          horarioAprox: action.payload.horarioAprox,
          hora: action.payload.hora,
        },
      };
    }
    case SET_VIAJE_VUELTA_ACTIVO: {
      return {
        ...state,
        vueltaActiva: true,
      };
    }
    case SET_MENSAJE_RANGO: {
      return {
        ...state,
        mensajeRango: action.payload,
      };
    }
    default:
      return state;
  }
};
